import React from "react";
import DeviceLogUpload from "../../components/attendance/DeviceLogUpload";

export default function StaffDeviceLogUploadPage() {
  return <DeviceLogUpload subjectType="STAFF" title="Staff Attendance — Device Data Upload" />;
}
